const checkApiData = {
  "QQ域名检测":{
    apiUrl:"qq",
    hasNode:false,
    params:[
      {
      name:"url",
      required:'是',
      type:'String',
      text:"您要检测的链接",
      default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "微信域名检测":{
    apiUrl:"vx",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "链接状态检测":{
    apiUrl:"httpcode",
    hasNode:true,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      },{
        name:"node",
        required:'否',
        type:'String',
        text:"节点列表ID，从下方节点列表中取值",
        default:'999999999'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "链接内容检测":{
    apiUrl:"web",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      },{
        name:"content",
        required:'否',
        type:'String',
        text:"要查询的关键词",
        default:'域名检测'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "被墙/污染检测-移动运营商":{
    apiUrl:"qiangcmcc",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "Ping检测":{
    apiUrl:"ping",
    hasNode:true,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      },{
        name:"node",
        required:'否',
        type:'String',
        text:"节点列表ID，从下方节点列表中取值",
        default:'999999999'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      },{
        name:"data.ip",
        type:'String',
        text:`链接的IP`,
      },{
        name:"data.url",
        type:'String',
        text:`网站地址`,
      },{
        name:"data.server_address",
        type:'String',
        text:`网站IP地址`,
      },{
        name:"data.cname",
        type:'String',
        text:`网站CNAME地址`,
      }
    ],
    resultJson:{
      "code": 201,
      "msg": "请求超时",
      "data": {
        "ip": "106.55.250.97",
        "url": "www.urlzt.com",
        "server_address": "北京市海淀区 北龙中网(北京)科技有限责任公司",
        "cname": "www.urlzt.com "
      }
    }
  },
  "端口Ping检测":{
    apiUrl:"tcping",
    hasNode:true,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      },{
        name:"node",
        required:'否',
        type:'String',
        text:"节点列表ID，从下方节点列表中取值",
        default:'999999999'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      },{
        name:"data.ip",
        type:'String',
        text:`链接的IP`,
      },{
        name:"data.url",
        type:'String',
        text:`网站地址`,
      },{
        name:"data.server_address",
        type:'String',
        text:`网站IP地址`,
      }
    ],
    resultJson:{
      "code": 200,
      "msg": "请求成功",
      "data": {
        "domain_ip": "106.55.250.97",
        "ping_min": "14.75ms",
        "ping_avg": "14.75ms",
        "ping_max": "14.75ms",
        "server_address": "北京市海淀区 北龙中网(北京)科技有限责任公司",
        "ip": "106.55.250.97",
        "url": "www.urlzt.com"
      }
    }
  },
  "国家反诈中心检测":{
    apiUrl:"antifraud",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "ICP备案检测":{
    apiUrl:"icp",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      },{
        name:"data.domain",
        type:'String',
        text:`站点域名`,
      },{
        name:"data.serviceLicence",
        type:'String',
        text:`备案号`,
      },{
        name:"data.natureName",
        type:'String',
        text:`备案类型`,
      },{
        name:"data.unitName",
        type:'String',
        text:`备案主体`,
      },{
        name:"data.updateRecordTime",
        type:'String',
        text:`备案时间`,
      }
    ],
    resultJson:{
      "code": 200,
      "data": {
        "contentTypeName": "",
        "domain": "urlzt.com",
        "domainId": 190002868935,
        "leaderName": "",
        "limitAccess": "否",
        "mainId": 110002255030,
        "mainLicence": "皖ICP备19022901号",
        "natureName": "企业",
        "serviceId": 190001945499,
        "serviceLicence": "皖ICP备19022901号-8",
        "unitName": "合肥极强臻科技有限公司",
        "updateRecordTime": "2021-12-23 10:32:23"
      },
      "msg": "已备案"
    }
  },
  "工信部黑名单检测":{
    apiUrl:"icpblack",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "被墙/污染检测":{
    apiUrl:"qiang",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "华为检测":{
    apiUrl:"huawei",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "360安全检测":{
    apiUrl:"qihu360",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "微博域名检测":{
    apiUrl:"wbjc",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "抖音域名检测":{
    apiUrl:"dyjc",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "域名hold检测":{
    apiUrl:"domainholdjc",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "绿标检测":{
    apiUrl:"gl",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "网安备案检测":{
    apiUrl:"wangan",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "备案接入商_阿里云接入检测":{
    apiUrl:"aliyun",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "备案接入商_腾讯云接入检测":{
    apiUrl:"tencent",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "备案接入商_百度云接入检测":{
    apiUrl:"baidu",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "备案接入商_西部数码接入检测":{
    apiUrl:"west",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "备案接入商_景安接入检测":{
    apiUrl:"zzidc",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "百度PC收录检测":{
    apiUrl:"baiduincluded",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "360PC收录检测":{
    apiUrl:"soincluded",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "搜狗PC收录检测":{
    apiUrl:"sogouincluded",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "谷歌PC收录检测":{
    apiUrl:"googleincluded",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "二级不死检测":{
    apiUrl:"llid",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "域名到期检测":{
    apiUrl:"domainexpires",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      },{
        name:"data.due_date",
        type:'String',
        text:`到期时间`,
      }
    ],
    resultJson:{
      "code": 200,
      "msg": "域名已注册",
      "data": {
        "due_date": "2025-04-02 01:46:04"
      }
    }
  },
  "谷歌安全检测":{
    apiUrl:"googlechrome",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "WHOIS检测":{
    apiUrl:"whois",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      },{
        name:"data.owner",
        type:'String',
        text:`拥有者`,
      },{
        name:"data.registrar",
        type:'String',
        text:`域名注册商`,
      },{
        name:"data.nameServers",
        type:'Array',
        text:`域名DNS`,
      },{
        name:"data.states",
        type:'Array',
        text:`域名状态`,
      },{
        name:"data.creationDate",
        type:'Array',
        text:`注册时间`,
      },{
        name:"data.expirationDate",
        type:'Array',
        text:`到期时间`,
      }
    ],
    resultJson:{
      "code": 200,
      "msg": "查询成功",
      "data": {
        "parserType": "common",
        "domainName": "urlzt.com",
        "whoisServer": "whois.dnspod.com",
        "nameServers": [
          "f1g1ns1.dnspod.net",
          "f1g1ns2.dnspod.net"
        ],
        "creationDate": 1585763164,
        "expirationDate": 1743529564,
        "updatedDate": 1659231019,
        "states": [
          "ok"
        ],
        "owner": "REDACTED FOR PRIVACY",
        "registrar": "DNSPod, Inc.",
        "dnssec": "unsigned"
      }
    }
  },
  "金山检测":{
    apiUrl:"jinshan",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "SSL证书过期检测":{
    apiUrl:"SSL",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "Uc浏览器检测":{
    apiUrl:"ucbrowser",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "微软域名检测":{
    apiUrl:"edge",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "连信检测":{
    apiUrl:"lianxincheck",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "多闪检测":{
    apiUrl:"dsjc",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "小米检测":{
    apiUrl:"mi",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "飞书检测":{
    apiUrl:"fsjc",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "安全联盟检测":{
    apiUrl:"anquanjc",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "中网可信检测":{
    apiUrl:"znet",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "百度信誉v认证检测":{
    apiUrl:"baiduxinyuv",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "知道创宇认证检测":{
    apiUrl:"chuangyu",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "知乎检测":{
    apiUrl:"zhjc",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "搜狗拦截检测":{
    apiUrl:"sogoujc",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "简书域名检测":{
    apiUrl:"jianshu",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "微信公众号检测":{
    apiUrl:"mpbanjc",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "微信小程序检测":{
    apiUrl:"mpappletsjc",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"输入小程序的唯一id（gh_开头）",
        default:"输入小程序的唯一id（gh_开头）"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "微信公众号文章检测":{
    apiUrl:"mpjc",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "腾讯文档检测":{
    apiUrl:"qqdocs",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "百度网盘链接检测":{
    apiUrl:"baidupan",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "微云网盘链接检测":{
    apiUrl:"weiyun",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "有道云笔记链接检测":{
    apiUrl:"youdao",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "石墨文档链接检测":{
    apiUrl:"shimo",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "蓝奏云网盘链接检测":{
    apiUrl:"lanzou",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "天翼网盘链接检测":{
    apiUrl:"tianyipan",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "诚通网盘链接检测":{
    apiUrl:"chengtong",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的链接",
        default:"www.urlzt.com"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
  "QQ号检测":{
    apiUrl:"qqban",
    hasNode:false,
    params:[
      {
        name:"url",
        required:'是',
        type:'String',
        text:"您要检测的QQ",
        default:"123456"
      },{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      },{
        name:"format",
        required:'否',
        type:'String',
        text:"json表示json格式返回,text表示文本格式返回",
        default:'json'
      }],
    resultKey:[
      {
        name:"code",
        type:'Number',
        text:`200:表示正常<br/>201:表示异常<br/>500:表示失败<br/>-1:表示点数不足、非法请求或API缺少参数<br/>-2:表示token不存在`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果,若异常则为异常原因`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
}

export default checkApiData
